import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import '../../App.css';
import { styled } from '../../components/styled';
import SpText from '../../components/atoms/SpText';
import SpButton from '../../components/atoms/SpButton';
import SpTextInput from '../../components/atoms/SpTextInput';
import { Add, ArrowBack, Close } from '@material-ui/icons';
import moment from 'moment';
import { Button as MuiButton, Divider, FormControlLabel, Grid, Radio } from '@material-ui/core';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { theme, theme as themeStyle } from '../../components/theme';
import { findUserById, updateUser } from '../../models/actions/Users';
import { registerUser } from '../../models/actions/Auth';
import { UserSessionContext } from '../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const UsersAdminDetail = (props) => {
  const [currentUser, setCurrentUser] = useState();
  const [error, setError] = useState(null);

  const { userID } = useParams();
  const history = useHistory();
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { register, control, getValues, handleSubmit, reset, setValue } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    if (userID) {
      try {
        let response = await findUserById({ id_user: userID }, authData.accessToken);
        if (response) {
          reset({ ...response });
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveUser = async () => {
    try {
      props.isLoading(true);
      if (userID) {
        const data = getValues();
        if (data.email && data.name && data.password) {
          const response = await updateUser({ user: { ...getValues() } }, authData.accessToken);
          if (response.message) {
            setCurrentUser(response);
            props.snackbarShowMessage(response.message);
          } else {
            props.snackbarShowErrorMessage(response.error);
          }
        } else {
          setError('Controlla i campi richiesti come obbligatori');
        }
        props.isLoading(false);
      } else {
        const response = await registerUser({ ...getValues() });
        if (!response?.data?.error) {
          props.isLoading(false);
          history.push('/admin/users');
          props.snackbarShowMessage(response.message);
        } else {
          props.isLoading(false);
          props.snackbarShowErrorMessage(response?.data?.error);
        }
      }
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const formControlStyleInput = { width: '100%', marginTop: '1%' };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%', paddingBottom: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push('/admin/users')}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {`Home / Utenti`}
              </SpText>
            </TitleToolbarSection>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
          style={{ backgroundColor: 'rgb(77, 172, 39,0.7)' }}
        >
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            {userID ? (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Modifica'}
                  style={{ width: '100%' }}
                  variant="h1PageTitle"
                  onClick={handleSubmit(saveUser)}
                />
              </Grid>
            ) : (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Salva'}
                  style={{ width: '100%' }}
                  ariant="h1PageTitle"
                  onClick={handleSubmit(saveUser)}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            style={{ paddingBottom: '2%' }}
          >
            <Grid
              item
              xs={12}
            >
              {error && <SpText variant="h4ComponentLabelError">{error}</SpText>}
            </Grid>
            <form>
              <SpTextInput
                label="Nome (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="name"
              />
              <SpTextInput
                label="Email (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="email"
              />
              {!userID && (
                <SpTextInput
                  label="Password (obbligatorio)"
                  labelColor={'black'}
                  type="string"
                  formControlStyle={formControlStyleInput}
                  variant="inputLabel"
                  inputRef={register}
                  name="password"
                />
              )}
            </form>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(UsersAdminDetail);
